<template>
    <v-card
        :color="color"
        :shaped="shaped"
        :height="height"
        :class="classCard"
        :style="styleCard"
        @click="select"
    >
        <component
            :is="current"
            :title="title"
            :subtitles="subtitles"
            :icon="icon"
            :classText="classText"
            :classSubtitle="classSubtitle"
        ></component>
    </v-card>
</template>

<script>

export default {
    props: [
        "color",
        "title",
        "subtitles",
        "icon",
        "componentCurrent",
        "shaped",
        "classText",
        "classSubtitle",
        "height",
        "classCard",
        "styleCard"
    ],

    data: () => ({
        current: null,
    }),

    created() {
        this.current = this.componentCurrent;
    },

    methods: {
        select(){

        }
    }
};
</script>

<style scoped>
.show-btns {
    color: rgba(255, 255, 255, 1) !important;
}
.v-card--reveal {
    align-items: center;
    top: 0;
    left: 0;
    justify-content: center;
    opacity: 0.9;
    position: absolute;
    width: 100%;
}
</style>